<template>
  <div
    v-if="show"
    class="overlayer"
  >
    <div class="sk-cube-grid centerer">
      <div class="sk-cube sk-cube1" />
      <div class="sk-cube sk-cube2" />
      <div class="sk-cube sk-cube3" />
      <div class="sk-cube sk-cube4" />
      <div class="sk-cube sk-cube5" />
      <div class="sk-cube sk-cube6" />
      <div class="sk-cube sk-cube7" />
      <div class="sk-cube sk-cube8" />
      <div class="sk-cube sk-cube9" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtScreenLoadingByTin',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.overlayer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255,255,255,0.5);
  z-index: 9998;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.centerer {
  position: absolute;
  z-index: 9999;
  top: calc(50% - 60px);
  left: calc(50% - 30px)
}

.sk-cube-grid {
  width: 60px;
  height: 60px;
  margin: 100px auto;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: var(--v-primary-lighten1);
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
          animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}
.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }
.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s; }
.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s; }
.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
          animation-delay: 0.1s; }
.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }
.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s; }
.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
          animation-delay: 0s; }
.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
          animation-delay: 0.1s; }
.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }

@-webkit-keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1);
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1);
  }
}
</style>
